<template>

<core-panel>

	<template v-slot:head>

		<h1>Plays</h1>

		<p>There are <b>{{ games.length }}</b> <plural t="game" :n="games.length" /> with {{ plays }}.</p>

	</template>

	<template v-slot:body>

		<app-game v-for="(item, index) in games" :item="item" v-bind:key="index" :isUserRating="isUser" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'plays',
			games: [],
			params: ['band']
		}

	},
	
	computed: {

		plays: function() {

			var plays = this.data.band

			if (plays === 2) {

				return '1 play'

			} else if (plays <= 6) {

				return (plays - 1).toString() + ' plays'

			} else if (plays == 7) {

				return '6 - 10 plays'

			} else if (plays == 8) {

				return '11 - 15 plays'

			} else if (plays == 9) {

				return '16 - 20 plays'

			} else if (plays == 10) {

				return '21 or more plays'

			}

			return ''

		}

	},

	methods: {

		response: function(json) {

			this.games = json.games

		}

	}

}

</script>